import { Area, AreaContent } from "../../useAreas/areas/types";
import hero from "../../../../assets/image/areas/hero/verkehrsrecht.webp";

const data: AreaContent = {
  id: Area.VERKEHRSRECHT,
  hero: hero,
  content: [
    "Wir unterstützen Sie im Verkehrsrecht sowie im Verkehrsstraf- und Ordnungswidrigkeitenrecht. Dabei vertreten wir Ihre Interessen sowohl bei der Abwehr als auch bei der Geltendmachung verkehrsrechtlicher Ansprüche.",
    "Insbesondere beraten und vertreten wir Sie bei:",
    [
      "der Verteidigung in Verkehrsstraf- und Ordnungswidrigkeitenverfahren, zum Beispiel bei Rotlichtverstößen, Geschwindigkeitsüberschreitungen oder Trunkenheit im Straßenverkehr",
      "der Vermeidung eines Fahrverbots",
      "der Wiedererlangung der Fahrerlaubnis, einschließlich Fragen zur MPU",
      "der Schadenregulierung nach einem Verkehrsunfall, insbesondere bei Reparaturkosten, Nutzungsausfall, Sachverständigenkosten und Schmerzensgeld",
      "der Geltendmachung von Ansprüchen gegenüber Unfallgegner:innen, Haftpflichtversicherungen oder der eigenen Fahrzeugversicherung",
      "rechtlichen Fragen zu Verträgen rund um das Kfz, insbesondere bei Leasing- und Finanzierungsverträgen",
    ],
  ],
  bullets: [
    "Verkehrsunfallabwicklung",
    "Ordnungswidrigkeiten und Straftaten",
    "Versicherungsrecht",
    "Verträge rund um das Kfz",
  ],
  more: [],
};

export default data;
